import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ParcelSizes } from "../../financial.types";
import { requestParcelSizes } from "./getParcelSizes.request";

const useGetParcelSizes = (
  options?: QueryOptions<{ parcelSize: ParcelSizes }, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["admin", "delivery", "settings"],
    queryFn: requestParcelSizes,
    onError: toastServerError,
    ...options
  });

  return { parcelSizes: data?.parcelSize, ...rest };
};

export default useGetParcelSizes;
